import { MessageCircle } from 'lucide-react';
import { useTrackEvent } from '@/hooks/useTrackEvent';

const WHATSAPP_URL = "https://api.whatsapp.com/send?phone=5561947568717&text=Ol%C3%A1,%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20como%20funcionam%20os%20atendimentos%20da%20Cl%C3%ADnica%20Habitus!";

// Flag para pausar/reativar o botão flutuante de WhatsApp em todo o site.
// Trocar para `true` para voltar a exibir.
const FLOATING_WHATSAPP_ENABLED = false;

const WhatsAppButton = () => {
  const { trackEventBeforeNavigation } = useTrackEvent();

  if (!FLOATING_WHATSAPP_ENABLED) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    trackEventBeforeNavigation('whatsapp_click', { source: 'floating_button' }, WHATSAPP_URL);
  };

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] hover:bg-[#20BD5A] text-white px-4 py-3 rounded-full shadow-lg hover:shadow-xl transition-all group"
      aria-label="Contato pelo WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="hidden sm:inline font-medium text-sm">
        Agendar
      </span>
    </a>
  );
};

export default WhatsAppButton;
